import navLogo from './assets/km_logo.png';
import squareLogo from './assets/KM-Logo-Square-Color.png';
import { faAnalytics, faRectangleHistory, faTachometerAlt } from '@fortawesome/pro-solid-svg-icons';
import { AppSettings } from '@konicaminolta/common-react';
import { ROLE_FULL_ADMINISTRATOR, ROLE_REPORT_VIEWER, ROLE_POWER_USER, SERVICE_ROLES } from './appRoles';
import Reports from './pages/Report/Reports';
import ReportDetails from './pages/Report/ReportDetails';
import Groups from './pages/Group/Groups';
import ReportViewer from './pages/Report/ReportViewer';
import Dashboards from './pages/Dashboard/Dashboards';
import DashboardDetails from './pages/Dashboard/DashboardDetails';
import DashboardViewer from './pages/Dashboard/DashboardViewer';

// Configure service Settings
export const appSettings: AppSettings = {
    navLogoAsset: navLogo,
    squareLogoAsset: squareLogo,
    basePath: "powerbireportviewer", // No slashes - empty string if no base path
    requireValidRole: false,
    adminRole: ROLE_FULL_ADMINISTRATOR,
    appRoles: SERVICE_ROLES,
    clientId: "9b07d2f2-7546-4f5e-a09a-d213f52f5d54",
    apiScopes: [
        "586fac2a-cb90-4fc0-872e-501794c1ece4", // IDP
        "cd4c1f1e-f38f-4ab9-87e4-8b7e85fcb670", // PowerBIReportViewerService
        '9c7ddfd2-18de-490e-bbab-8ecd41e78759', // Notification Service API
    ],
    routes: [
        {
            name: "Dashboard",
            path: "/dashboards",
            component: Dashboards,
            requireAnyRoles: [ROLE_FULL_ADMINISTRATOR, ROLE_POWER_USER, ROLE_REPORT_VIEWER]
        },
        {
            name: "View Dashboard",
            path: "/dashboards/viewdashboard/:dashboardId",
            component: DashboardViewer,
            requireAnyRoles: [ROLE_FULL_ADMINISTRATOR, ROLE_REPORT_VIEWER, ROLE_POWER_USER]
        },
        {
            name: "Dashboard Details",
            path: "/dashboards/:dashboardId",
            component: DashboardDetails,
            requireAnyRoles: [ROLE_FULL_ADMINISTRATOR, ROLE_POWER_USER, ROLE_REPORT_VIEWER]
        },

        {
            name: "Report",
            path: "/",
            component: Reports,
            requireAnyRoles: [ROLE_FULL_ADMINISTRATOR, ROLE_POWER_USER, ROLE_REPORT_VIEWER]
        },
        {
            name: "View Report",
            path: "/reports/viewreport/:reportId",
            component: ReportViewer,
            requireAnyRoles: [ROLE_FULL_ADMINISTRATOR, ROLE_REPORT_VIEWER, ROLE_POWER_USER]
        },
        {
            name: "Report Details",
            path: "/reports/:reportId",
            component: ReportDetails,
            requireAnyRoles: [ROLE_FULL_ADMINISTRATOR, ROLE_POWER_USER, ROLE_REPORT_VIEWER]
        },
        {
            name: "Groups",
            path: "/groups",
            component: Groups,
            requireAnyRoles: [ROLE_FULL_ADMINISTRATOR, ROLE_POWER_USER]
        }
    ],
    menuItems: [
        {
            name: 'Report',
            menuIcon: faAnalytics,
            path: '/',
        },
        {
            name: 'Groups',
            menuIcon: faRectangleHistory,
            path: '/groups',
        },
        {
            name: 'Dashboard',
            menuIcon: faTachometerAlt,
            path: '/dashboards',
        }
    ],
    signalR: {
        actionHandlers: [],
        eventHandlers: []
    },
}